var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box", attrs: { id: "cards" } },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "div",
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", appear: "" } },
                    [
                      _c("MetricGraph", {
                        attrs: {
                          metrics: _vm.metrics,
                          name: "Throughput",
                          date: _vm.date,
                          period: _vm.period
                        },
                        on: { updateMetric: _vm.updateMetric }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.displayBoards.length > 0 && _vm.activeType == "group"
                    ? _c("div", [
                        _c("div", { staticClass: "card" }, [
                          _c("h4", { staticClass: "card-heading" }, [
                            _vm._v("Boards"),
                            _c("span", { staticClass: "board-count" }, [
                              _vm._v(_vm._s(_vm.displayBoards.length))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "dl",
                            [
                              _vm._l(_vm.displayBoards, function(contract) {
                                return [
                                  _c(
                                    "dt",
                                    {
                                      key: contract.contract,
                                      staticClass: "contracts",
                                      class: [
                                        {
                                          "hover-contract":
                                            _vm.hoverContract ==
                                            contract.contract
                                        },
                                        {
                                          "inactive-contract":
                                            _vm.hoverContract !=
                                            contract.contract
                                        }
                                      ],
                                      on: {
                                        mouseover: function($event) {
                                          _vm.hoverContract = contract.contract
                                        },
                                        mouseout: function($event) {
                                          _vm.hoverContract = null
                                        },
                                        click: function($event) {
                                          return _vm.updateContract(
                                            contract.contract
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(contract.contract))]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      key:
                                        contract.contract +
                                        contract.count.toString()
                                    },
                                    [_vm._v(_vm._s(contract.count))]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.report.members.length > 0 && _vm.activeType == "contract"
                    ? _c("div", [
                        _c("div", { staticClass: "card" }, [
                          _c("h4", { staticClass: "card-heading" }, [
                            _vm._v("People")
                          ]),
                          _vm._v(" "),
                          _c(
                            "dl",
                            [
                              _vm._l(_vm.report.members, function(member) {
                                return [
                                  _c(
                                    "dt",
                                    {
                                      key: member.member,
                                      staticClass: "members-list",
                                      class: [
                                        {
                                          "active-member":
                                            _vm.activeMember == member.member
                                        },
                                        {
                                          "hover-member":
                                            _vm.hoverMember == member.member &&
                                            _vm.activeMember != member.member
                                        },
                                        {
                                          "inactive-member":
                                            _vm.activeMember != member.member &&
                                            _vm.hoverMember != member.member
                                        }
                                      ],
                                      on: {
                                        click: function($event) {
                                          return _vm.setActiveMember(
                                            member.member
                                          )
                                        },
                                        mouseover: function($event) {
                                          _vm.hoverMember = member.member
                                        },
                                        mouseout: function($event) {
                                          _vm.hoverMember = null
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(member.member))]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      key:
                                        member.member + member.count.toString()
                                    },
                                    [_vm._v(_vm._s(member.count))]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.settings.cards.labels &&
                  _vm.report.labels &&
                  _vm.report.labels.length > 0 &&
                  _vm.activeType == "contract"
                    ? _c("div", [
                        _c("div", { staticClass: "card" }, [
                          _c("h4", { staticClass: "card-heading" }, [
                            _vm._v("Labels")
                          ]),
                          _vm._v(" "),
                          _c(
                            "dl",
                            [
                              _vm._l(_vm.report.labels, function(label) {
                                return [
                                  _c(
                                    "dt",
                                    {
                                      key: label.label,
                                      staticClass: "label-list",
                                      class: [
                                        {
                                          "active-label":
                                            _vm.activeLabel == label.label
                                        },
                                        {
                                          "hover-label":
                                            _vm.hoverLabel == label.label &&
                                            _vm.activeLabel != label.label
                                        },
                                        {
                                          "inactive-label":
                                            _vm.activeLabel != label.label &&
                                            _vm.hoverLabel != label.label
                                        }
                                      ],
                                      on: {
                                        click: function($event) {
                                          return _vm.setActiveLabel(label.label)
                                        },
                                        mouseover: function($event) {
                                          _vm.hoverLabel = label.label
                                        },
                                        mouseout: function($event) {
                                          _vm.hoverLabel = null
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(label.label))]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      key: label.label + label.count.toString()
                                    },
                                    [_vm._v(_vm._s(label.count))]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.displayMetrics && _vm.displayCards.length > 0
                    ? _c("div", [
                        _c("div", { staticClass: "card" }, [
                          _c("h4", [_vm._v("Metrics")]),
                          _vm._v(" "),
                          _c("dl", [
                            _c("dt", [_vm._v("Throughput")]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.displayCards.length) +
                                  " " +
                                  _vm._s(
                                    _vm.cardPlural(_vm.displayCards.length)
                                  )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("dl", [
                            _c("dt", [_vm._v("Avg top planned")]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.displayMetrics.queue) +
                                  " " +
                                  _vm._s(
                                    _vm.dayPlural(_vm.displayMetrics.queue)
                                  )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("dl", [
                            _c("dt", [_vm._v("Avg in progress")]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(_vm.displayMetrics.cycle) +
                                  " " +
                                  _vm._s(
                                    _vm.dayPlural(_vm.displayMetrics.cycle)
                                  )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("dl", [
                            _c("dt", [_vm._v("Unplanned")]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  Math.round(
                                    (_vm.displayMetrics.unplanned /
                                      _vm.displayCards.length) *
                                      100
                                  )
                                ) + " %"
                              )
                            ])
                          ])
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.report.members.length > 0 && _vm.activeType == "group"
                    ? _c("div", [
                        _c("div", { staticClass: "card" }, [
                          _c("h4", { staticClass: "card-heading" }, [
                            _vm._v("People")
                          ]),
                          _vm._v(" "),
                          _c(
                            "dl",
                            [
                              _vm._l(_vm.report.members, function(member) {
                                return [
                                  _c(
                                    "dt",
                                    {
                                      key: member.member,
                                      staticClass: "members-list",
                                      class: [
                                        {
                                          "active-member":
                                            _vm.activeMember == member.member
                                        },
                                        {
                                          "hover-member":
                                            _vm.hoverMember == member.member &&
                                            _vm.activeMember != member.member
                                        },
                                        {
                                          "inactive-member":
                                            _vm.activeMember != member.member &&
                                            _vm.hoverMember != member.member
                                        }
                                      ],
                                      on: {
                                        click: function($event) {
                                          return _vm.setActiveMember(
                                            member.member
                                          )
                                        },
                                        mouseover: function($event) {
                                          _vm.hoverMember = member.member
                                        },
                                        mouseout: function($event) {
                                          _vm.hoverMember = null
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(member.member))]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      key:
                                        member.member + member.count.toString()
                                    },
                                    [_vm._v(_vm._s(member.count))]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.settings.cards.labels &&
                  _vm.report.labels &&
                  _vm.report.labels.length > 0 &&
                  _vm.activeType == "group"
                    ? _c("div", [
                        _c("div", { staticClass: "card" }, [
                          _c("h4", { staticClass: "card-heading" }, [
                            _vm._v("Labels")
                          ]),
                          _vm._v(" "),
                          _c(
                            "dl",
                            [
                              _vm._l(_vm.report.labels, function(label) {
                                return [
                                  _c(
                                    "dt",
                                    {
                                      key: label.label,
                                      staticClass: "label-list",
                                      class: [
                                        {
                                          "active-label":
                                            _vm.activeLabel == label.label
                                        },
                                        {
                                          "hover-label":
                                            _vm.hoverLabel == label.label &&
                                            _vm.activeLabel != label.label
                                        },
                                        {
                                          "inactive-label":
                                            _vm.activeLabel != label.label &&
                                            _vm.hoverLabel != label.label
                                        }
                                      ],
                                      on: {
                                        click: function($event) {
                                          return _vm.setActiveLabel(label.label)
                                        },
                                        mouseover: function($event) {
                                          _vm.hoverLabel = label.label
                                        },
                                        mouseout: function($event) {
                                          _vm.hoverLabel = null
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(label.label))]
                                  ),
                                  _c(
                                    "dd",
                                    {
                                      key: label.label + label.count.toString()
                                    },
                                    [_vm._v(_vm._s(label.count))]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("WorkCards", {
              attrs: {
                displayCards: _vm.displayCards,
                period: _vm.period,
                settings: _vm.settings
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45e64419", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45e64419","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Cards.vue
// module id = null
// module chunks = 